
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
const PageConst= {
  ACTION: {
    doDelete: { api: 'M0030SchoolYearNameService.M21501_doDelete' },
    doBrowse: { api: 'M0030SchoolYearNameService.M21501_doBrowse' },
    getEdit: { api: 'M0030SchoolYearNameService.M21501_getEdit'},
    doEdit: { api: 'M0030SchoolYearNameService.M21501_doEdit'},
    doAdd: { api: 'M0030SchoolYearNameService.M21501_doAdd'},
  },
}

const module = {
  state: {
    PageConst,
    total_row_count : 0,
  },
  getters: {
  },
  mutations: {},
  actions: {
    async M21501_doBrowse_AtDataTable({dispatch, state}) {
      return await dispatch('doBrowse_AtDataTable', {
        orderBy: state.orderBy,
        pagination: state.pagination
      });
    },
    async M21501_doAdd({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M0030SchoolYearNameService.M21501_doAdd', input: payload },
        ]
      })
    },
    async M21501_getEdit({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M0030SchoolYearNameService.M21501_getEdit', input: payload },
        ]
      }).then((res) => {
        return res[0].output;
      })
    },
    async M21501_doEdit({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M0030SchoolYearNameService.M21501_doEdit', input: payload },
        ]
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
